import { Text } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { EmailField } from "@src/appV2/lib";
import { useFormContext } from "react-hook-form";

interface VerifyEmailFormProps {
  onSubmit: (values: { email: string }) => Promise<void>;
  id: string;
}

export function VerifyEmailForm(props: VerifyEmailFormProps) {
  const { onSubmit, id } = props;
  const { handleSubmit } = useFormContext<{ email: string }>();

  return (
    <Box
      component="form"
      id={id}
      sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}
      onSubmit={handleSubmit(async (formData) => {
        await onSubmit(formData);
      })}
    >
      <Text sx={{ pb: 1 }}>Please enter your email address to verify your account.</Text>
      <EmailField name="email" showLabel={false} />
    </Box>
  );
}
